// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c5dcedd4","67":"9dd27265","75":"f728761f","80":"ed4f94eb","214":"0a756dad","381":"8252df03","465":"f0604d4f","771":"18a5fc7d","787":"4c8b65ad","856":"00c4da9d"}[chunkId] + ".chunk.js";
};